// extracted by mini-css-extract-plugin
export default {"pdf-container":"LoadPdf_pdf-container__NsNL8","pdf":"LoadPdf_pdf__SUViA","buttons":"LoadPdf_buttons__LlsBj","download":"LoadPdf_download__pNosT","cancel":"LoadPdf_cancel__duNbw"};